export const checkRefereeWishLocation = (
  referee,
  locationId,
  fieldId = null
) => {
  let value = (referee.location || {})[locationId];
  if (value === undefined) {
    value = "all";
  }
  if (value === "none") {
    return false;
  } else if (value !== "all" && value !== "none") {
    if (value.length === 0) {
      return false;
    } else {
      if (fieldId) {
        if (value.indexOf(fieldId) !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  } else {
    return true;
  }
};
